import moment from 'moment';
import memoize from 'fast-memoize';
// Defines Bucket selection checks
const DAILY_WINDOW_MAX = 34;
const WEEKLY_WINDOW_MAX = 105;

const xAxisLabels = {
    daily: 'Date',
    weekly: 'Week Start',
    monthly: 'Month'
};

const calculateWindowSize = (start, end) => Math.floor(moment.duration(end.diff(start)).asDays()) + 1;

const getTimeBucketConfig = (startDate, endDate) => {
    const windowSize = calculateWindowSize(startDate, endDate);
    const config = { windowSize, xAxisLabels };
    if (windowSize <= DAILY_WINDOW_MAX) {
        config.selector = 'daily';
        config.xAxisLabel = xAxisLabels.daily;
    } else if (windowSize > DAILY_WINDOW_MAX
        && windowSize <= WEEKLY_WINDOW_MAX) {
        config.selector = 'weekly';
        config.xAxisLabel = xAxisLabels.weekly;
    } else {
        config.selector = 'monthly';
        config.xAxisLabel = xAxisLabels.monthly;
    }

    return config;
};

const getBucketParams = (bucket) => {
    let timeInc;
    let startOf;
    switch (bucket) {
    case 'weekly':
        timeInc = 'weeks';
        startOf = 'week';
        break;
    case 'monthly':
        timeInc = 'months';
        startOf = 'month';
        break;
    case 'daily':
    default:
        timeInc = 'days';
        startOf = 'day';
    }

    return { timeInc, startOf };
};

const buildTimeBuckets = (startDate, endDate) => {
    const config = getTimeBucketConfig(startDate, endDate);

    const categories = ['daily', 'weekly', 'monthly'].reduce((prev, bucket) => {
        const { timeInc, startOf } = getBucketParams(bucket);
        const dateIterator = moment.utc(startDate).startOf(startOf);
        const lastDate = moment.utc(endDate).startOf(startOf);

        while (dateIterator.diff(lastDate) <= 0) {
            prev[bucket].push(dateIterator.startOf(startOf).valueOf());

            dateIterator.add(1, timeInc);
        }
        return prev;
    }, {
        daily: [],
        weekly: [],
        monthly: []
    });

    config.buckets = categories[config.selector];
    config.sparkline = [];

    const { timeInc, startOf } = getBucketParams(config.selector);
    const dateIterator = moment.utc(startDate.clone()).subtract(config.windowSize, 'days').startOf('day');
    const lastDate = moment.utc(endDate.clone()).subtract(config.windowSize, 'days').startOf('day');

    while (dateIterator.diff(lastDate) <= 0) {
        config.sparkline.push(dateIterator.startOf(startOf).valueOf());

        dateIterator.add(1, timeInc);
    }

    config.sparkline.push(...config.buckets);

    return {
        config,
        ...categories
    };
};

exports.timeBucketsGenerator = memoize(buildTimeBuckets, {
    serializer: args => args.map(a => a.format('YYYY-MM-DD')).join('_')
});

exports.generateTimeRangeKey = apiConfig => `${apiConfig.start().format()}_${apiConfig.end().format()}`;



// WEBPACK FOOTER //
// ./src/helpers/timeBuckets.js